import { computed } from 'vue'

import { useUiStore, type Direction } from '@/shared/ui/store/uiStore'

/** Read/control text direction. Stamping `dir` on <html> is wired once in App.vue. */
export function useDirection() {
  const store = useUiStore()
  return {
    direction: computed(() => store.direction),
    setDirection: (value: Direction) => store.setDirection(value),
  }
}
